/**
 * Join Page Observability Constants
 *
 * Event names tracked for join form submissions.
 */

export const JOIN_FORM_SUBMIT_FAILURE = 'join_form_submit_failure' as const;
